import React from "react";
import { ServiceVersionSelectionStateContext } from "./service-version-selection-context";

export const useServiceVersionSelectionState = () =>
  React.useContext(ServiceVersionSelectionStateContext);
